import { PropsWithChildren } from 'react'
import AccessDenied from '../../../components/AccessDenied'
import { useHasAdminManagementAccess } from '../permissions/usePermissions'

export default function AdminManagementGuard({ children }: PropsWithChildren) {
  const hasAdminManagementAccess = useHasAdminManagementAccess()

  if (!hasAdminManagementAccess) {
    return <AccessDenied />
  }

  return <>{children}</>
}
